/**
 * ProcessedDataChart Constants
 */

export const DEFAULT_MAX_POINTS = 4000;
export const DEFAULT_COLOR = "#14B8A6";
export const LOCALE = "de-DE";
export const CHART_HEIGHT = 400;
